bam-quote {

  .bam-quote__image-cta-wrapper {
    display: flex;
    flex-direction: column;
    justify-content: space-between;

    @include tablet {
      flex-direction: row;
    }

    .bam-quote__image-wrapper {
      display: flex;

      .bam-quote__image > * {
        width: 62px;
        margin-right: 16px;
      }
    }

    bal-button {
      align-self: flex-start;
      margin-top: 48px;

      @include tablet {
        align-self: flex-end;
        margin-top: 0;
      }

      a {
        padding-right: 0 !important;
      }
    }
  }
}
